<template>
	<div id="login" class="authenticate">
		<app-head title="Update Password" />

		<v-card elevation="0">
			<v-card-title>
				<div class="d-flex w-100">
					<h5 class="text-h5 mb-3 font-weight-bold">
						Update Password
					</h5>
					<div class="ml-auto">
						<v-icon>mdi-lock-check-outline</v-icon>
					</div>
				</div>
			</v-card-title>
			<v-card-text>
				<v-alert v-if="exists(form.errors.email)" color="red lighten-2" dark>{{ form.errors.email }}</v-alert>
				<v-form v-model="valid" @submit.prevent="handleForm">
					<v-text-field
						v-model="form.password"
						:error="exists(form.errors.password)"
						:hide-details="!exists(form.errors.password)"
						:error-messages="form.errors.password"
						label="New Password"
						type="password"
						class="mb-3"
						required
						persistent-placeholder
						outlined></v-text-field>
					<v-text-field
						v-model="form.password_confirmation"
						:error="exists(form.errors.password_confirmation)"
						:hide-details="!exists(form.errors.password_confirmation)"
						:error-messages="form.errors.password_confirmation"
						label="New Password (again)"
						type="password"
						class="mb-3"
						required
						persistent-placeholder
						outlined
						:disabled="!form.password"></v-text-field>
					<v-divider class="my-4" />
					<div class="d-flex align-center">
						<v-btn
							elevation="0"
							large
							rounded
							color="primary"
							type="submit"
							:loading="form.processing">
							Change Password
						</v-btn>
						<div class="ml-4">or</div>
						<div class="ml-5">
							<Link :href="route('login')" class="v-size--default theme--light text-decoration-none text--secondary">
								Back to Login
							</Link>
						</div>
					</div>
				</v-form>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import Auth from '@/Layouts/Auth'
import AppHead from '@/Shared/AppHead'

export default {
	components: { AppHead },
	layout: Auth,
	props: {
		token: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			valid: false,
			form: this.$inertia.form({
				token: this.token,
				email: this.$page.props.email,
				password: null,
				password_confirmation: null
			})
		}
	},
	methods: {
		handleForm () {
			this.form.post(this.route('password.update', this.token), {
				onSuccess: () => {
					this.message = 'New password updated successfully.'
					this.snackbar = true
					this.$inertia.visit(this.route('login'))
				}
			})
		}
	}
}
</script>
